import { render, staticRenderFns } from "./DaVenue.vue?vue&type=template&id=077a8c6f&"
import script from "./DaVenue.vue?vue&type=script&lang=js&"
export * from "./DaVenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports